import { useEffect } from 'react';
import { useIPGContext } from './useIPGContext';
import queryString from 'query-string';
import useIPGPayment from './useIPGPayment';

const IPGPayment = (): JSX.Element => {
    const { iframeURL } = useIPGContext();
    const { verifyIPGPayment } = useIPGPayment();

    useEffect(() => {
        const popupOverlay = document.getElementById('pupayment_overlay');
        const popupContainer = document.getElementById('pupayment_popupContainer');

        window.addEventListener('message', event => {
            if (event.data.action === 'PuPayment_Close') {
                if (event.data.data.returnURL) {
                    const returnedURL = event.data.data.returnURL;

                    // console.info(`returned url: `, returnedURL);
                    // example returned url: PS_SIGNATURE=2ffe0ad153ba7e0fbe94f57de09aef5d73c7595f&PS_EXPIRETIME=1715998567&PS_SIGTYPE=PSSHA1&notification_type=order&order_id=80059715&order_reference=663e6e51-f313-ef11-9f89-002248943d33&pass_through=test&test_transaction=1

                    const parsedResponseQuery = queryString.parse(returnedURL);

                    if (parsedResponseQuery.order_id && parsedResponseQuery.order_reference) {
                        // console.info('verify payment..');

                        verifyIPGPayment({
                            orderId: parsedResponseQuery.order_id as string,
                            orderReference: parsedResponseQuery.order_reference as string,
                        });
                    }
                } else if (popupOverlay && popupContainer) {
                    popupOverlay.style.display = 'none';
                    popupContainer.style.display = 'none';
                    // reload the page if user close the popup payment
                    window.location.reload();
                }
            }
        });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    });

    if (!iframeURL) {
        return (
            <div>Error initialize IPG payment</div>
        );
    }

    return (
        <div>
            <div
                id="pupayment_overlay"
                style={{
                    display: 'block',
                    position: 'fixed',
                    left: '0px',
                    top: '0px',
                    width: '100vw',
                    height: 'calc(var(--vh, 1vh) * 100)',
                    textAlign: 'center',
                    zIndex: '1040',
                    background: 'rgb(0, 0, 0) none repeat scroll 0% 0%',
                    opacity: '0.7',
                }}
            />

            <div
                id="pupayment_popupContainer"
                style={{
                    display: 'block',
                    position: 'fixed',
                    top: '0',
                    left: '0',
                    right: '0',
                    bottom: '0',
                    zIndex: '1050',
                    width: '100vw',
                    height: 'calc(var(--vh, 1vh) * 100)',
                }}
            >
                {/* eslint-disable-next-line react/iframe-missing-sandbox */}
                <iframe
                    src={iframeURL}
                    style={{
                        width: '100%',
                        minWidth: '100%',
                        height: '100%',
                        backgroundColor: 'transparent',
                        border: 'none',
                    }}
                    id="popupFrame"
                    name="popupFrame"
                    width="100%"
                    height="100%"
                    seamless={true}
                />
            </div>
        </div>
    );
};

export default IPGPayment;
